/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecurityDashboardLayoutPutRequest
 */
export interface SecurityDashboardLayoutPutRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SecurityDashboardLayoutPutRequest
     */
    layout?: { [key: string]: any; };
}

/**
 * Check if a given object implements the SecurityDashboardLayoutPutRequest interface.
 */
export function instanceOfSecurityDashboardLayoutPutRequest(value: object): value is SecurityDashboardLayoutPutRequest {
    return true;
}

export function SecurityDashboardLayoutPutRequestFromJSON(json: any): SecurityDashboardLayoutPutRequest {
    return SecurityDashboardLayoutPutRequestFromJSONTyped(json, false);
}

export function SecurityDashboardLayoutPutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityDashboardLayoutPutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'layout': json['layout'] == null ? undefined : json['layout'],
    };
}

export function SecurityDashboardLayoutPutRequestToJSON(json: any): SecurityDashboardLayoutPutRequest {
    return SecurityDashboardLayoutPutRequestToJSONTyped(json, false);
}

export function SecurityDashboardLayoutPutRequestToJSONTyped(value?: SecurityDashboardLayoutPutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'layout': value['layout'],
    };
}

